(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "antd/lib/button/index.js", "antd/lib/input/index.js", "antd/lib/select/index.js", "antd/lib/checkbox/index.js", "antd/lib/radio/index.js", "antd/lib/auto-complete/index.js", "antd/lib/switch/index.js", "antd/lib/slider/index.js", "antd/lib/modal/index.js", "antd/lib/date-picker/index.js", "antd/lib/time-picker/index.js", "antd/lib/input-number/index.js", "antd/lib/rate/index.js", "antd/lib/cascader/index.js", "antd/lib/tree-select/index.js", "antd/lib/upload/index.js"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("antd/lib/button/index.js"), require("antd/lib/input/index.js"), require("antd/lib/select/index.js"), require("antd/lib/checkbox/index.js"), require("antd/lib/radio/index.js"), require("antd/lib/auto-complete/index.js"), require("antd/lib/switch/index.js"), require("antd/lib/slider/index.js"), require("antd/lib/modal/index.js"), require("antd/lib/date-picker/index.js"), require("antd/lib/time-picker/index.js"), require("antd/lib/input-number/index.js"), require("antd/lib/rate/index.js"), require("antd/lib/cascader/index.js"), require("antd/lib/tree-select/index.js"), require("antd/lib/upload/index.js"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.index, global.index, global.index, global.index, global.index, global.index, global.index, global.index, global.index, global.index, global.index, global.index, global.index, global.index, global.index, global.index);
    global.unknown = mod.exports;
  }
})(this, function (_exports, _index, _index2, _index3, _index4, _index5, _index6, _index7, _index8, _index9, _index10, _index11, _index12, _index13, _index14, _index15, _index16) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _index = _interopRequireDefault(_index);
  _index2 = _interopRequireDefault(_index2);
  _index3 = _interopRequireDefault(_index3);
  _index4 = _interopRequireDefault(_index4);
  _index5 = _interopRequireDefault(_index5);
  _index6 = _interopRequireDefault(_index6);
  _index7 = _interopRequireDefault(_index7);
  _index8 = _interopRequireDefault(_index8);
  _index9 = _interopRequireDefault(_index9);
  _index10 = _interopRequireDefault(_index10);
  _index11 = _interopRequireDefault(_index11);
  _index12 = _interopRequireDefault(_index12);
  _index13 = _interopRequireDefault(_index13);
  _index14 = _interopRequireDefault(_index14);
  _index15 = _interopRequireDefault(_index15);
  _index16 = _interopRequireDefault(_index16);
  var _default = {
    Input: _index2.default,
    Button: _index.default,
    Select: _index3.default,
    Checkbox: _index4.default,
    Radio: _index5.default,
    AutoComplete: _index6.default,
    Switch: _index7.default,
    Slider: _index8.default,
    DatePicker: _index10.default,
    TimePicker: _index11.default,
    InputNumber: _index12.default,
    Rate: _index13.default,
    Cascader: _index14.default,
    TreeSelect: _index15.default,
    Upload: _index16.default,
    Modal: _index9.default
  };
  _exports.default = _default;
});